
// Update line item properties with the current store ID, and whether or not BBs are being redeemed, from the cart attributes.
// This is used for the custom carrier at checkout.
const lineItemAttributeSetter = {

  bound: false,
  running: false,

  log: function () {
    if (window.location.hash == "#enable-lias-debug"){
      console.log('lineItemAttributeSetter:', ...arguments)
    }
  },

  init: function() {
    if (this.bound){
      return;
    }
    this.bound = true;

    let _this = this;
    document.addEventListener("cart:ready", (e) => {
      _this.log('trigger:', "cart:ready" )
      _this.run();
    });
    document.addEventListener("cart:updated", (e) => {
      _this.log('trigger:', "cart:updated" )
      _this.run();
    });

    // Listen for the store selector change and hope we catch it before the user goes to checkout, i guess?
    // If this is a real race, consider disabling the checkout button while lineItemAttributeSetter finishes
    document.addEventListener("cartStoreChanged", (e) => {
      _this.log('trigger:', "cartStoreChanged" )
      _this.run();
    });

    fetch('/cart.js').then(res => res.json()).then(cartData => {
      let storeId = cartData.attributes._store_id ?? null;
      _this.log("storeId on load:", storeId);
      if (storeId){
        _this.log("calling run:")
        _this.run();
      }
    })

  },

  run: function () {
    this.log("run called", this.running)
    if (!this._running){
      this.log("starting run")
      this.running = true;
      let _this = this;
      fetch('/cart.js').then(res => res.json()).then(cartData => {
        _this.log("cart.js came back...")
        let storeId = cartData.attributes._store_id ?? null;

        if (storeId){
          let changePromises = cartData.items.filter((item) => {
            return item.properties?._store_id != storeId
          }).map((item) => {
            let newProperties = {
              ...item.properties,
              _store_id: storeId
            };
            return () => new Promise((resolve) => {
              _this.log("Property update promise "+item.key)
              fetch('/cart/change.js', {
                'method': 'POST',
                'headers': {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  id: item.key,
                  quantity: item.quantity,
                  properties: newProperties
                })
              })
              .then(res => res.json())
              .then(data => {
                resolve(data)
              });
            })
          })

          if (changePromises.length){
            _this.log("Updating "+changePromises.length+" items...");
            Promise.all(
              changePromises.map(promise => promise().then(()=>{_this.log('[1 cart item updated]')}))
            ).then(() => {
              _this.log("All items updated - done")
              _this.running = false;
            })
          } else {
            _this.log("Nothing to update - done")
            _this.running = false;
          }
        }

      }).catch((e) => {
        _this.log("error (- done)", e)
        _this.running = false;
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', lineItemAttributeSetter.init());
